import varAxios from "../../Comman/axios";
import {AddUpdatePasswordSetting,GetPasswordSetting,GetCompanyBrandingList,AddCompanyBranding} from '../../Comman/apiEndPoints';
export const ADD_COMPANY_REQUEST= "ADD_COMPANY_REQUEST";
export const GET_COMPANY_REQUEST = "GET_COMPANY_REQUEST";
export const APPLICATION_REQUEST="APPLICATION_REQUEST";

export const ADD_PASSWORD= "ADD_PASSWORD";
export const PASSWORD_REQUEST="PASSWORD_REQUEST"

export function getCompanyBrandingList() {
    return (dispatch) => {
      dispatch(ApplicationRequest(true)); 

        return varAxios.get(GetCompanyBrandingList)
            .then((response) => {
                debugger
              dispatch(
                 fetchGetCompanyBrandingListSuccessData(
                false,
            response.data.errorCode,
               response.data.statusCode,
                response.data.brandlist
            )
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
 export function ApplicationRequest(isLoading){
    return {
      type : APPLICATION_REQUEST,
      isLoading
    }
  }
export function fetchGetCompanyBrandingListSuccessData(isLoading,errorCode,statusCode,brandList) {
    debugger
    return {
        type : ADD_COMPANY_REQUEST,
       isLoading,
      errorCode,
      statusCode,
      brandList
    }
}
export function addCompanyBranding(body) {
    
    return (dispatch) => {
        return varAxios.post(AddCompanyBranding,body,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
               /*  dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                ); */
                this.getCompanyBrandingList();
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

export function getPasswordSetting() {
    return (dispatch) => {
      dispatch(PasswordSettingRequest(true)); 

        return varAxios.get(GetPasswordSetting)
            .then((response) => {
              dispatch(
                 fetchGetPasswordSettingSuccessData(
                false,
            response.data.errorCode,
               response.data.statusCode,
                response.data.brandlist
            )
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
 export function PasswordSettingRequest(isLoading){
    return {
      type : PASSWORD_REQUEST,
      isLoading
    }
  }
export function fetchGetPasswordSettingSuccessData(isLoading,errorCode,statusCode,brandList) {
    debugger
    return {
        type : ADD_PASSWORD,
       isLoading,
      errorCode,
      statusCode,
      brandList
    }
}
export function addPasswordSetting(body) {
    
    return (dispatch) => {
        return varAxios.post(AddUpdatePasswordSetting,body,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
               /*  dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                ); */
                this.getPasswordSetting();
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
